<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-slot:app-bar-btn>
				<v-btn color="white" text @click="$router.push({ name: 'manufacture_order_index' })">
					<v-icon class="mr-1">mdi-clipboard-list-outline</v-icon>
					製造オーダー一覧
				</v-btn>
			</template>
			<ManufactureOrderSearchForm
				:query="q"
				:categories="categories"
				hideStatus
				@search-infos="searchOrderIndividualInfos($event)"
			/>
			<v-divider class="mt-4" />
			<v-row no-gutters justify="end" class="mt-4">
				<IssueOrderConfirmationDialog
					:disabled="!selectedInfos.length"
					:selectedInfos="selectedInfos"
					@issue-manufacture-orders="issueManufactureOrders"
				/>
			</v-row>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					v-model="selectedInfos"
					:items="order_individual_infos"
					item-key="id"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
					show-select
					@click:row="openDialog"
				>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		</CommonFlame>
		<OrderIndividualInfoShowDialog
			:dialog.sync="dialog"
			:id="selectedId"
			@update-info="fetchOrderIndividualInfos(q, pagination.current)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import ManufactureOrderSearchForm from "./components/ManufactureOrderSearchForm.vue"
import IssueOrderConfirmationDialog from "./components/IssueOrderConfirmationDialog.vue"
import OrderIndividualInfoShowDialog from "../order_individual_info/components/OrderIndividualInfoShowDialog.vue"
import moment from "moment/min/moment.min.js"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		ManufactureOrderSearchForm,
		IssueOrderConfirmationDialog,
		OrderIndividualInfoShowDialog,
	},

	data() {
		return {
			title: "未発行製造オーダー一覧",
			order_individual_infos: [],
			selectedInfos: [],
			authority_flag: false,
			categories: [],
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				delivery_info_planned_shipping_date_lteq: null,
				delivery_info_planned_shipping_date_gteq: null,
				ordered_product_product_number_cont: null,
				ordered_product_product_product_category_id_eq: null,
				ordered_product_product_name_cont: null,
			},
			selectedId: null,
			dialog: false,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchOrderIndividualInfos(this.q, page, true)
	},
	methods: {
		fetchOrderIndividualInfos(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			q.order_status_in = ["waiting"]
			q.status_in = ["order_received"]
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/manufacture_orders/order_individual_infos", {
					params,
					headers,
				})
				.then((response) => {
					this.order_individual_infos = response.data.order_individual_infos

					this.order_individual_infos.map((info) => {
						if (info.delivery_info && info.delivery_info.deadline != null) {
							info.delivery_info.deadline = moment(info.delivery_info.deadline).format("YYYY/MM/DD")
						}

						if (info.delivery_info && info.delivery_info.planned_shipping_date != null) {
							info.delivery_info.planned_shipping_date = moment(
								info.delivery_info.planned_shipping_date
							).format("YYYY/MM/DD")
						}

						if (info.pic_users.length > 0) {
							info.pic_user = info.pic_users[0].full_name
						} else {
							info.pic_user = ""
						}
						if (info.teams.length > 0) {
							info.team = info.teams[0].name
						} else {
							info.team = ""
						}
					})

					this.pagination = response.data.pagination
					if (first_visit) {
						this.categories = response.data.categories
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		issueManufactureOrders() {
			const headers = authenticate.setHeader()
			const ids = this.selectedInfos.map((info) => info.id)
			const params = { order_individual_info_ids: ids }
			axios
				.put("/erp/v1/manufacture_orders/order_individual_infos", params, { headers })
				.then((response) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "製造オーダーを発行しました",
					})
					this.fetchOrderIndividualInfos(this.q, this.pagination.current)
					this.selectedInfos = []
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openDialog(item) {
			this.selectedId = item.id
			this.dialog = true
		},
		getPage(page) {
			this.fetchOrderIndividualInfos(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchOrderIndividualInfos(q) {
			this.q = q
			this.fetchOrderIndividualInfos(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}

function headers() {
	return [
		{
			text: "オーダー状態",
			value: "order_status_i18n",
			width: "100px",
		},
		{
			text: "状態",
			value: "status_i18n",
			width: "120px",
		},
		{
			text: "製造番号",
			value: "ordered_product.product_number",
			width: "150px",
		},
		{
			text: "枝番",
			value: "sub_number",
			width: "60px",
		},
		{
			text: "分類",
			value: "ordered_product.product.product_category.name",
			width: "150px",
		},
		{
			text: "品名",
			value: "ordered_product.product.name",
			width: "200px",
		},
		{
			text: "数量",
			value: "quantity",
			width: "100px",
		},
		{
			text: "向け先",
			value: "ordered_product.matter.customer_company.name",
			width: "200px",
		},
		{
			text: "出荷予定日",
			value: "delivery_info.planned_shipping_date",
			width: "200px",
		},
		{
			text: "納期",
			value: "delivery_info.deadline",
			width: "200px",
		},
		{
			text: "製造担当チーム",
			value: "team",
			width: "200px",
		},
		{
			text: "製造担当者",
			value: "pic_user",
			width: "200px",
		},
	]
}
</script>
